<template>
    <div>
        <v-row>
            <v-col class="py-2">
                <autocompleteOneForm
                    label="Proyecto"
                    :loading="loadingProjects"
                    :valueInput="values.project_id"
                    :rule="rules.required"
                    :items="serverItems.projects"
                    :errorMessages="serverErrors.project_id"
                    @valueChange="(v) => {values.project_id = v; delete serverErrors.project_id}"
                ></autocompleteOneForm>
            </v-col>
        </v-row>

        <v-row>
            <v-col class="py-2">
                <textFieldForm 
                    @valueChange="(v) => {values.emitted_by = v; delete serverErrors.emitted_by}" 
                    :valueInput="values.emitted_by" 
                    :rule="rules.required" 
                    label="Emitido por"
                    :errorMessages="serverErrors.emitted_by"
                ></textFieldForm>
            </v-col>
        </v-row>

        <v-row>
            <v-col class="py-2">
                <textFieldForm 
                    @valueChange="(v) => {values.delivered_by = v; delete serverErrors.delivered_by}" 
                    :valueInput="values.delivered_by" 
                    :rule="rules.required" 
                    label="Entregado por"
                    :errorMessages="serverErrors.delivered_by"
                ></textFieldForm>
            </v-col>
        </v-row>

        <v-row>
            <v-col class="py-2">
                <textFieldForm 
                    @valueChange="(v) => {values.received_by = v; delete serverErrors.received_by}" 
                    :valueInput="values.received_by" 
                    :rule="rules.required" 
                    label="Recibido por"
                    :errorMessages="serverErrors.received_by"
                ></textFieldForm>
            </v-col>
        </v-row>
        
        <v-row>
            <v-col class="py-2">
                <datePickerForm
                    label="Fecha de emisión"
                    :valueInput="values.date"
                    :rule="rules.required"
                    @valueChange="(v) => {values.date = v; delete serverErrors['date']}"
                    :errorMessages="serverErrors['date']"
                ></datePickerForm>
            </v-col>
        </v-row>

        <v-row>
            <v-col class="py-2">
                <textAreaForm 
                    @valueChange="(v) => {values.resource = v.trim(); delete serverErrors['resource']}" 
                    :valueInput="values.resource" 
                    :rule="rules.required" 
                    label="Insumo/Documento"
                    :errorMessages="serverErrors['resource']"
                    :rows="1"
                ></textAreaForm>
            </v-col>
        </v-row>
        
               
        <v-row>
            <v-col class="py-2">
                <autocompleteOneForm
                    label="Concepto"
                    :loading="loadingConcepts"
                    :valueInput="values.concept_id"
                    :rule="rules.required"
                    :items="serverItems.concepts"
                    :errorMessages="serverErrors.concept_id"
                    @valueChange="(v) => {
                        values.concept_id = v;
                        delete serverErrors.concept_id
                    }"
                ></autocompleteOneForm>
            </v-col>
        </v-row>

        <v-row>
            <v-col class="py-2">
                <textAreaForm
                    :refinput="'myTextarea'"
                    @valueChange="(v) => {values.reference = v; delete serverErrors.reference}" 
                    :valueInput="values.reference" 
                    :rule="[...rules.required,...rules.max500]" 
                    label="Observaciones"
                    :maxChars="500"
                    :errorMessages="serverErrors.reference"
                ></textAreaForm>
            </v-col>
        </v-row>
               
    </div>
</template>

<script>
import TableItems from "../incomes/TableItems.vue";
import Utils from '../../helpers/Utils';

/* eslint-disable */
export default {
    props: ['values', 'serverErrors', 'edit', 'inputCreditNotes'],
    components: {
       'table-items': TableItems
    },
    data(){
        return {
            ut: Utils,
            loadingProjects: false,
            loadingConcepts: false,
            dynamicRows: 3,
            rules: {
				required: [
					v => !!v || 'El campo requerido'
				],
				max500: [
                    v => {
                       if(v != undefined && v != null && v.length > 500)
                        return 'El campo no puede ser mayor a 500 caracteres' 
                        return true;
                    }
				],
               
                amount: [
                    v => {
                        if(v!= null && !v.toString().match("^[0-9]+(\.[0-9]{1,4})?$"))
                            return 'Solo números válidos';
                        if(v === null || v.toString().trim() === '')
                            return 'El campo es requerido'
                        return true;
                    }
                ],
               
				current_mxn_per_usd: [
                    v => {
                        if(v!= null && !v.toString().match("^[0-9]+(\.[0-9]{1,4})?$"))
                            return 'Solo números válidos';
                        if(v === null || v.toString().trim() === '')
                            return 'El campo es requerido';
                        if(v === 0 || v === '0' || v<=0)
                            return 'El campo debe ser máyor a 1';
                        return true;
                    }
                ],
            },
            serverItems: {
                projects:[ 
                ],
                concepts: [
                ],
            },

          
        }
    },
    computed: {
        
    },
    watch: { 
       
        
    },
    mounted(){
        this.getProjects();
        this.getConcepts();
    },
    methods: {
       
        getProjects()
        {
            this.loadingProjects = true;
            this.$api.projectsReceipts.getSelect(this.$store.state.business)
				.then((resp) =>{
					this.serverItems.projects = resp.data.map((x) => {
                        return {text: x.name, value: x.slug}
                    });
				})
				.catch((error) =>{
					console.log(error, "error");
				})
				.finally(() => {
                    this.loadingProjects = false;
				})
			;
        },

        getConcepts()
        {
            this.loadingConcepts = true;
            this.$api.conceptsXCE.getSelect(this.$store.state.business)
				.then((resp) =>{
					this.serverItems.concepts = resp.data.map((x) => {
                        return {text: x.text, value: x.value}
                    });
				})
				.catch((error) =>{
					console.log(error, "error");
				})
				.finally(() => {
                    this.loadingConcepts = false;
				})
			;
        },
    }
}
</script>

<style>

</style>